import type { FC } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { ErrorBoundary } from 'react-error-boundary';

import './styles/global.scss';

import { ErrorView } from './ErrorView';
import { Init } from './Init';
import { Layout } from './Layout';
import { SurveyView } from '../survey';
import { PageNotFoundError } from './logic';

export const AppView: FC = observer(() => {
  return (
    <ErrorBoundary FallbackComponent={Layout}>
      <BrowserRouter>
        <Routes>
          <Route path={'/'} element={<Layout />}>
            <Route
              path="/new/poll/:ift?/:cm_id"
              element={
                <Init>
                  <SurveyView />
                </Init>
              }
            />
            <Route path="*" element={<ErrorView error={new PageNotFoundError()} />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
});
